export default "__VITE_ASSET__985a623d__"